import { render, staticRenderFns } from "./PlanQuestionView.vue?vue&type=template&id=4cc1391c&scoped=true"
import script from "./PlanQuestionView.vue?vue&type=script&lang=js"
export * from "./PlanQuestionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc1391c",
  null
  
)

export default component.exports